import { Directive, ElementRef, HostListener, Input, AfterViewInit } from '@angular/core';
import { PermissionCheckerService } from 'abp-ng2-module';
import {
    LanguageServiceProxy,
} from '../service-proxies/service-proxies';
import {
    UpdateLanguageTextInput,
    IUpdateLanguageTextInput
} from 'axilla-shared-dto';
import { TranslationsService } from './translations.service';

declare var abp: any;

@Directive({
    selector: '[translation]'
})
export class TranslationDirective implements AfterViewInit{
    ngAfterViewInit(): void {
        if (this.print) {
            this.el.nativeElement.innerHTML = this.translate(this.key, this.source || this.localizationSourceName);
        }
    }

    _key: string;
    get key(): string {
        return this._key;
    }
    @Input('translation') set key(value: string) {
        this._key = value;

        if (this.print) {
            this.el.nativeElement.innerHTML = this.translate(this.key, this.source || this.localizationSourceName);
        }
    }

    @Input('isAdmin') isAdmin: any;

    _source: string;
    get source(): string {
        return this._source;
    }
    @Input('source') set source(value: string) {
        this._source = value;

        if (this.print) {
            this.el.nativeElement.innerHTML = this.translate(this.key, this.source || this.localizationSourceName);
        }
    }
    
    @Input('print') print: any = 'true';
    @Input('textArea') textArea: boolean = false;

    private ESCAPE_KEYCODE = 27;
    private localizationSourceName = "Axilla";

    private prevHtml: any;
    private value: any;

    private languagePermission = 'Pages.Administration.Languages';

    constructor(
        private el: ElementRef,
        private _languageService: LanguageServiceProxy,
        private _permissionCheckerService: PermissionCheckerService,
        private translationsService: TranslationsService) {
    }


    translate(key: string, source: string) {
        let text = abp.localization.localize(key, source);

        for (let source of this.translationsService.localizationSources) {
            text = abp.localization.localize(key, source);

            if (text != key) break;
        }

        return text;
    }

    @HostListener('click', ['$event'])
    clickEvent(event) {
        //check if user has Pages.Administration.Languages Permission
        if (this._permissionCheckerService.isGranted(this.languagePermission) || this.isAdmin) {
            if (event.ctrlKey) {
                event.preventDefault();
                event.stopPropagation();

                this.prevHtml = this.el.nativeElement.innerHTML;

                if (this.textArea) {
                    this.el.nativeElement.innerHTML = `<div><textarea id="focus" style="width:95%;min-width:100px;"></textarea></div>`;
                } else {
                    this.el.nativeElement.innerHTML = `<div><input id="focus" style="width:95%;min-width:100px;"/></div>`;
                }
                document.getElementById('focus').focus();
            }

            let el = document.getElementById('focus');
            if (el) {
                event.preventDefault();
                event.stopPropagation();

                document.getElementById('focus').focus();
            }
        }
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event) {
        //check if user has Pages.Administration.Languages Permission
        if (this._permissionCheckerService.isGranted(this.languagePermission) || this.isAdmin) {
            if (event.keyCode == 32) {
                event.preventDefault();
                event.stopPropagation();

                event.target.value = `${event.target.value} `;
            }

            if (event.ctrlKey && event.key === 'Enter') {
                this.value = event.target.value;

                let source = this.localizationSourceName;
                if (this.source) {
                    source = this.source;
                }

                let input: IUpdateLanguageTextInput = {
                    key: this.key,
                    languageName: abp.localization.currentLanguage.name,
                    sourceName: source,
                    value: this.value
                }
                let a = this._languageService.updateLanguageText(new UpdateLanguageTextInput(input))
                    .subscribe(() => {
                        this.el.nativeElement.innerHTML = this.value;
                    });

            } else if (event.keyCode === this.ESCAPE_KEYCODE) {
                this.el.nativeElement.innerHTML = this.prevHtml;
            }
        }
    }
}
